var _defs, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19.5,
    height: 19.5,
    viewBox: "0 0 19.5 19.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#91919c;}"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.426,10.353l-2.173-.369a7.715,7.715,0,0,0-.472-1.128l1.271-1.784a.68.68,0,0,0-.062-.861L18.247,4.468a.656.656,0,0,0-.861-.062L15.6,5.678a6.876,6.876,0,0,0-1.128-.472l-.349-2.153A.661.661,0,0,0,13.47,2.5H11.009a.661.661,0,0,0-.656.554L9.984,5.227A7.715,7.715,0,0,0,8.856,5.7L7.072,4.427a.68.68,0,0,0-.861.062L4.468,6.232a.656.656,0,0,0-.062.861L5.678,8.877A6.876,6.876,0,0,0,5.207,10l-2.153.349a.661.661,0,0,0-.554.656V13.47a.661.661,0,0,0,.554.656l2.173.369A7.715,7.715,0,0,0,5.7,15.623L4.427,17.407a.68.68,0,0,0,.062.861l1.743,1.743a.656.656,0,0,0,.861.062L8.877,18.8A6.876,6.876,0,0,0,10,19.273l.369,2.173A.661.661,0,0,0,11.03,22H13.49a.661.661,0,0,0,.656-.554l.349-2.194a7.715,7.715,0,0,0,1.128-.472l1.784,1.271a.68.68,0,0,0,.861-.062l1.743-1.743a.656.656,0,0,0,.062-.861L18.8,15.6a6.876,6.876,0,0,0,.472-1.128l2.173-.369A.661.661,0,0,0,22,13.449v-2.44A.7.7,0,0,0,21.426,10.353ZM12.24,15.746a3.506,3.506,0,1,1,3.506-3.506A3.5,3.5,0,0,1,12.24,15.746Z",
    transform: "translate(-2.5 -2.5)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.e440e158a263205948b4e2ee57839fc3.svg";
export { ForwardRef as ReactComponent };